'use strict';
var round = Math.round;

module.exports = function (it) {
  var value = round(it);
  return value < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/to-uint8-clamped.js
// module id = 690
// module chunks = 0